import React from 'react';

import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { SecaoColunasDinamicasForm, SecaoListColunasDinamicasComp } from 'pages/cadastro/colunas-dinamicas/components';
import { ColunasDinamicasProvider } from 'pages/cadastro/colunas-dinamicas/contexts/ColunasDinamicasContext';

export function ColunasDinamicasForm() {
    const { hasFormPermission, alertNotPermission } = usePermissionsContext();
    const { id } = useParams();

    if (!hasFormPermission('LOJA', id)) return alertNotPermission();

    return (
        <ListagemProvider>
            <ColunasDinamicasProvider>
                <FormProvider>
                    <SecaoColunasDinamicasForm />
                </FormProvider>
            </ColunasDinamicasProvider>
        </ListagemProvider>
    );
}

export function SecaoListColunasDinamicas() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['LOJA_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <SecaoListColunasDinamicasComp />
        </ListagemProvider>
    );
}
